export default {
  'purchasesAbcCurveReport.form.filterByDate': 'Filtrar por data de',
  'purchasesAbcCurveReport.form.filterByDate.launch': 'Lançamento',
  'purchasesAbcCurveReport.form.filterByDate.emission': 'Emissão',

  'purchasesAbcCurveReport.form.classificationByImportance':
    'Classificação por importância',
  'purchasesAbcCurveReport.form.classificationByImportance.quantity':
    'Quantidade',
  'purchasesAbcCurveReport.form.classificationByImportance.value': 'Valor',
};
